import Api from './api';

const favoritesListRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/favorites', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const createFavoritesRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/favorites', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const transferCar = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/transfer-favorite/' + data.id , data.query, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteFavoritesRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/favorites', { params: data, headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}

export default { favoritesListRequest, createFavoritesRequest, deleteFavoritesRequest, transferCar }



// WEBPACK FOOTER //
// ./src/api/apiFavorites.js